import type { ContactFormData, ContactFormResponse } from '../types/contact-form';

export class FormSubmitter {
  async submit(data: ContactFormData): Promise<ContactFormResponse> {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const response = await fetch(
      window.certlex_ajax?.url || '/wp-admin/admin-ajax.php',
      {
        method: 'POST',
        body: formData,
      }
    );

    return await response.json();
  }

  trackConversion(): void {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'contact_form_submission', {
        event_category: 'engagement',
        event_label: 'Contact Form',
      });
    }
  }
}